import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import PopularDestination from '../PopularDestination';
import RecentSearches from '../RecentSearches';

import type { PopularDestination as PopularDestinationType } from '../../../types';
import type { I18nService } from '@shared/types/i18n';

import STYLES from './RecentSearchAndPopularsMobile.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  i18n: I18nService;
  suggestion: PopularDestinationType;
  onSuggestionSelected: Function;
  onBlur: Function;
};

const cls = cssModules(STYLES);

const RecentSearchAndPopularsMobile = ({
  i18n: { translate },
  onBlur,
  onSuggestionSelected,
  suggestion,
}: Props) => {
  const hasPopular =
    suggestion.popularDestinations && suggestion.popularDestinations.length > 0;
  return (
    <section>
      <RecentSearches
        onSuggestionSelected={onSuggestionSelected}
        onBlur={onBlur}
        isMobile
      />
      {hasPopular && (
        <section>
          <div className={cls('RecentSearchAndPopularsMobile__popularTitle')}>
            {translate('Auto_Suggest_popularDestination_label')}
          </div>
          <div
            className={cls(
              'RecentSearchAndPopularsMobile__popularDestinations',
            )}
          >
            {suggestion.popularDestinations &&
              suggestion.popularDestinations.map((popular, index) => (
                <PopularDestination
                  key={popular.entityId}
                  popular={popular}
                  index={index}
                  onSuggestionSelected={onSuggestionSelected}
                  onBlur={onBlur}
                  isMobile
                />
              ))}
          </div>
        </section>
      )}
    </section>
  );
};

export default withI18n(RecentSearchAndPopularsMobile);
